import React, { useEffect } from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, useSearchParams } from "react-router-dom";
import { PlayerProvider, usePlayer } from "@/context/PlayerContext";
import { AppStateProvider } from "@/context/AppState";
import { I18nProvider } from "@/context/I18nContext";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import { Toaster } from "sonner";
import { api } from "@/lib/api";

// Handle ?station=uuid deep link auto-play
function DeepLinkHandler() {
  const [params, setParams] = useSearchParams();
  const { playStation } = usePlayer();
  useEffect(() => {
    const uuid = params.get("station");
    if (!uuid) return;
    api.stationByUuid(uuid)
      .then((station) => {
        if (station) playStation(station);
      })
      .catch((err) => console.warn("[voix] deep link failed:", err))
      .finally(() => {
        params.delete("station");
        setParams(params, { replace: true });
      });
  }, []);
  return null;
}

function App() {
  return (
    <I18nProvider>
      <PlayerProvider>
        <AppStateProvider>
          <BrowserRouter>
            <DeepLinkHandler />
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
              </Routes>
            </Layout>
          </BrowserRouter>
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: {
                background: "#0a0a0a",
                border: "1px solid #1a1a1a",
                color: "#f8fafc",
                fontFamily: "'Azeret Mono', monospace",
                fontSize: "12px",
                letterSpacing: "0.03em",
              },
            }}
          />
        </AppStateProvider>
      </PlayerProvider>
    </I18nProvider>
  );
}

export default App;
